import moment from "moment";

import { DateRangePicker } from "../../react/utils/dateRangePicker/DateRangePicker";

import template from "./pOvertimesEmployee.html";

export function pOvertimesEmployeeDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pOvertimesEmployeeController,
    controllerAs: 'pOvertimesEmployee',
    bindToController: true
  };

  return directive;
}

class pOvertimesEmployeeController {
  constructor ($filter, $interval, Auth, DownloadFile, Stats, Notes, ConnectionQuality, $translate, $scope) {
    'ngInject';

    this.$filter = $filter;
    this.Auth = Auth;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.showModal = false;
    this.overtimeUserModal = '';
    this.$translate = $translate;
    this.$scope = $scope;

    this.$scope.$watch(() => this.showModal, () => this.updateView());

    this.headersOvertime = [
      {
        id: "date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.DATE"),
        name: this.$translate.instant("OVERTIME.DATE"),
        class: "table-info"
      },
      {
        id: "worknorm",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORKNORM"),
        name: this.$translate.instant("OVERTIME.WORKNORM"),
        class: "table-info worknorm"
      },
      {
        id: "type",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORK_TYPE"),
        name: this.$translate.instant("OVERTIME.TYPE"),
        class: "table-info"
      },
      {
        id: "workTime",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.WORK_TIME"),
        name: this.$translate.instant("OVERTIME.WORK_TIME"),
        class: "table-info"
      },
      {name: null, class: "table-160"},
      // {
      //   id: "applicationOvertime",
      //   name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
      //   class: "table-info application-overtime",
      //   tooltip: this.$translate.instant("STATS.TOOLTIP.APPLICATION_OVERTIME")
      // },
      // {
      //   id: "allocatedApplicationOvertime",
      //   name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
      //   class: "table-info",
      //   tooltip: this.$translate.instant("STATS.TOOLTIP.ALLOCATED_APPLICATION_OVERTIME")
      // },
      {
        id: "reported",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.REPORTED_OVERTIME"),
        name: this.$translate.instant("OVERTIME.REPORTED"),
        class: "table-info"
      },
      {
        id: "accepted",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.ACCEPTED_OVERTIME"),
        name: this.$translate.instant("OVERTIME.ACCEPT"),
        class: "table-info"
      },
      {
        id: "comment",
        tooltip: this.$translate.instant("STATS.TOOLTIP.OVERTIME.COMMENT"),
        name: this.$translate.instant("OVERTIME.COMMENT"),
        class: "table-info"
      },
      {id: "acceptAll", name: null, class: "table-mode"}
    ];

    this.filteredHeadersOvertime = this.headersOvertime.filter(h => h.id !== "acceptAll");

    this.state = "loading";
    this.isFirstRun = true;

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");

        let dateStartInStorage = sessionStorage.getItem("roedl-tl-date-start");
        let dateEndInStorage = sessionStorage.getItem("roedl-tl-date-end");

        if(dateStartInStorage){
          this.dateStartChoice = dateStartInStorage;
          this.dateEndChoice = dateEndInStorage;
        }


        if (this.overtimeApplicationsFlag) {
          this.filteredHeadersOvertime.splice(
            5,
            0,
            {
              id: "applicationOvertime",
              name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
              class: "table-info application-overtime",
              tooltip: this.$translate.instant("STATS.TOOLTIP.APPLICATION_OVERTIME")
            },
            {
              id: "totalAllocatedOvertimeRequest",
              name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
              class: "table-info",
              tooltip: this.$translate.instant("STATS.TOOLTIP.ALLOCATED_APPLICATION_OVERTIME")
            }
          );
        }

        this.refreshOvertime();
        //this.Stats.getWorklogs(this.dateStartChoice, this.dateEndChoice);

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getMoreData() {
    this.state = "loading";
    this.viewToggledOut = false;

    this.refreshOvertime();
  }

  updateDates(values) {
    this.dateStart = moment(values[0]);
    this.dateEnd = moment(values[1]);

    this.dateStartChoice = this.dateStart.format("YYYY-MM-DD");
    this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");

    this.viewToggledOut = moment.duration(this.dateEnd.diff(this.dateStart)).asDays() > 9;

    //save date to session storage
    sessionStorage.setItem("roedl-tl-date-start" , this.dateStartChoice);
    sessionStorage.setItem("roedl-tl-date-end" , this.dateEndChoice);

    if (!this.viewToggledOut) {
      this.getMoreData();
    }
  }

  filterUsers() {
    this.filtersOpen = !this.filtersOpen;
    this.allUsersSelected = this.summary.users.every(u => u.visible);
  }

  selectAllUsers() {
    this.summary.users.forEach(u => u.visible = this.allUsersSelected);
    sessionStorage.setItem("roedl-tl-filtered-users", angular.toJson(this.summary.users.map( u => {return {name: u.name, id: u.id , visible: u.visible};})));
  }

  deselectUser() { // run on change of any filter-user checkbox
    if (this.allUsersSelected && this.summary.users.find(u => u.visible != true)) {
      this.allUsersSelected = false;
    }

    if (!this.allUsersSelected && this.summary.users.every(u => u.visible == true)) {
      this.allUsersSelected = true;
    }
    sessionStorage.setItem("roedl-tl-filtered-users", angular.toJson(this.summary.users.map( u => {return {name: u.name, id: u.id , visible: u.visible};})));
  }

  exportData() {
    this.state = "loading";
    return this.Stats.exportOvertimeEmployee(this.dateStartChoice, this.dateEndChoice).then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix-${this.dateStartChoice}-${this.dateEndChoice}-${moment().format("HH:mm")}.xlsx`
        );
    }, (error) => {
      this.error = error;
      this.state = 'error';
    });
  }

  deserializeData(usersWithEntries) {
    const filteredUsers = angular.fromJson(sessionStorage.getItem("roedl-tl-filtered-users"));
    var users = usersWithEntries.map( userWithEntries => {
      const filteredUserVisibility = filteredUsers && filteredUsers.find(user => user.id == userWithEntries.user.id);
      return {
        name: userWithEntries.user.fullName,
        id: userWithEntries.user.id,
        visible: filteredUsers &&  filteredUserVisibility ? filteredUserVisibility.visible : true,
        isInCurrentTeam: userWithEntries.isInCurrentTeam,
        isBlocked: userWithEntries.user.blockedAt && moment().isSameOrAfter(userWithEntries.user.blockedAt),
        teamId: userWithEntries.workdayTimes[0] ? userWithEntries.workdayTimes[0].teamId : userWithEntries.user.teamId
      };

    });
    users.sort((a,b) => a.name.localeCompare(b.name));
    var summary = {
      date: moment(this.dateStartChoice).format("YYYY-MM-DD")+ " — " +moment(this.dateEndChoice).format("YYYY-MM-DD"),
      users: users
    };
    const employee = summary.users.filter(user => user.id === this.user.id);

    let employeeSummary = {
      date: summary.date,
      users: employee
    };

    return employeeSummary;
  }

  refreshOvertime(overtime, update) {
    this.Stats.getOvertimesEmployeeView(this.dateStartChoice, this.dateEndChoice, update).then(
      (success) => {
        let isDateInSessionStorage = sessionStorage.getItem("roedl-tl-date-start");

        if(overtime)
          overtime.saving = false;

        if(this.isFirstRun){
          if(!isDateInSessionStorage){
            this.dateStartChoice = moment(success.data.from).format("YYYY-MM-DD");
            this.dateEndChoice = moment(success.data.to).format("YYYY-MM-DD");
            sessionStorage.setItem("roedl-tl-date-start" , this.dateStartChoice);
            sessionStorage.setItem("roedl-tl-date-end" , this.dateEndChoice);
          }

          this.DateRangePicker = DateRangePicker;
          this.dateRangePickerProps = {
            defaultValue: [new Date(this.dateStartChoice), new Date(this.dateEndChoice)],
            onChange: (values) => this.updateDates(values)
          };
          
          this.isFirstRun = false;
        }

        this.state = "loaded";
        this.stateLoadingBalance = "loaded";

        this.overtimeTableMaker(success.data);
      },
      (error) => {
        this.state = "error";
        this.stateOvertime = "error";
        this.error = error;
      }
    );
  }

  overtimeTableMaker( data ) {
    this.summary = this.deserializeData(data.overtimeSummaries);

    this.summaryOvertime = {};
    data.overtimeSummaries.map( userOvertime => {
      userOvertime.workdayTimes.map( o => {
          o.accepted = o.isAccepted || o.acceptedOvertime == o.reportedOvertime;
          o.undertime = moment.duration(o.reportedOvertime) < 0;
          o.noOvertime = moment.duration(o.reportedOvertime) <= 0;
          o.edited = o.canUpdateOvertime && !o.noOvertime && !o.accepted;
          o.comment = o.overtimeAcceptComment;
          if(o.edited) o.durationText = this.$filter("hms")(o.reportedOvertime);
      });
      this.summaryOvertime[userOvertime.user.id + (userOvertime.workdayTimes[0] ? userOvertime.workdayTimes[0].teamId : userOvertime.user.teamId)] = {
        name: userOvertime.user.fullName,
        isUndertime: moment.duration(userOvertime.cumulatedOvertime) < 0,
        totalCumulatedOvertime: this.$filter("hms")(userOvertime.cumulatedOvertime),
        acceptedBalanceFromPreviousYears: userOvertime.acceptedBalanceFromPreviousYears,
        overtimes: userOvertime.workdayTimes.sort((a,b)=> new Date(a.date) - new Date(b.date)),
        cumulatedApplicationOvertime: this.$filter("hms")(userOvertime.cumulatedApplicationOvertime),
        allocatedApplicationOvertime: userOvertime.allocatedApplicationOvertime,
        settledApplicationOvertime: this.$filter("hms")(userOvertime.settledApplicationOvertime),
        acceptedApplicationBalanceFromPreviousYears: this.$filter("hms")(userOvertime.acceptedApplicationBalanceFromPreviousYears)
      };
    });
    this.LongTermLeaveIdList = [];

    Object.keys(this.summaryOvertime).forEach( key => {
      const overtimesAcceptedWithoutUndertime = this.summaryOvertime[key].overtimes.filter(overtime => moment.duration(overtime.reportedOvertime) >= 0 && overtime.accepted).length;
      const allOvertimes = this.summaryOvertime[key].overtimes.length;
      const overtimesWithoutUndertime = this.summaryOvertime[key].overtimes.filter(overtime => moment.duration(overtime.reportedOvertime) < 0).length;
      const LongTermLeave = this.summaryOvertime[key].overtimes.filter(overtime => {
          return overtime.expectedWorknorm.positionType === "LongTermLeave";
      }).length;

      if(LongTermLeave === allOvertimes && allOvertimes!== 0) {
        this.LongTermLeaveIdList.push(key);
      }

      this.summaryOvertime[key].allAcceptedOvertimes = overtimesAcceptedWithoutUndertime == (allOvertimes - overtimesWithoutUndertime);
      let sumOfOvertimeValue = (value) => {
        let overtimes = this.summaryOvertime[key].overtimes.map(o => o[value]);
        let sumOfovertimesInMiliseconds = 0;
        if(overtimes.length>0){
          sumOfovertimesInMiliseconds = overtimes.reduce((sum , curr) => moment.duration(sum)+ moment.duration(curr));
        }
        return moment.duration(sumOfovertimesInMiliseconds).toJSON();
      };

      this.summaryOvertime[key].totalAcceptedOvertime = this.$filter("hms")(sumOfOvertimeValue("acceptedOvertime"));
      this.summaryOvertime[key].totalReportedOvertime = this.$filter("hms")(sumOfOvertimeValue("reportedOvertime"));
      this.summaryOvertime[key].totalApplicationOvertime = this.$filter("hms")(sumOfOvertimeValue("applicationOvertime"));
      this.summaryOvertime[key].totalAllocatedOvertimeRequest = this.$filter("hms")(sumOfOvertimeValue("allocatedApplicationOvertime"));
    });
    let usersOnLongTermLeave = this.summary.users.filter( user => {
      return this.LongTermLeaveIdList.indexOf(user.id) >= 0;
    });
    this.summary.users = this.summary.users.filter( user => {
      return this.LongTermLeaveIdList.indexOf(user.id) < 0;
    }).concat(usersOnLongTermLeave);
  }

  acceptOvertimeStart(originalOvertime) {
    this.state = "loading";
    originalOvertime.saving = true;
    let overtime = {
      userId: originalOvertime.userId,
      date: originalOvertime.date,
      duration: originalOvertime.reportedOvertime,
      comment: originalOvertime.comment
    };
    return this.Stats.editOvertime(overtime).then(
      () => {
        return Promise.resolve();
      },
      () => {
        this.state = "error";
        originalOvertime.error = true;
        return Promise.reject();
      }
    );
  }

  acceptOvertime(originalOvertime) {
    this.acceptOvertimeStart(originalOvertime).then(() => {
      this.refreshOvertime(originalOvertime, 'update');
    });
  }

  acceptAllOvertimesRecurency(items) {
    if(!items.length) {
      this.refreshOvertime(null, 'update');
      return Promise.resolve();
    }
    const first = items[0];
    const rest = items.slice(1);
    this.acceptOvertimeStart(first).then(
      () => {
        this.acceptAllOvertimesRecurency(rest);
      },
      () => {
        this.refreshOvertime(null, 'update');
      }
    );
  }

  acceptAllOvertime(user) {
    this.state = "loading";
    const items = this.summaryOvertime[user.id + user.teamId].overtimes
    .filter((x) => (!x.edited || !x.saving) && moment.duration(x.reportedOvertime) > 0 && moment.duration(x.acceptedOvertime) == 0 );

    this.acceptAllOvertimesRecurency(items);
  }

  editOvertimeStart(originalOvertime) {
    originalOvertime.edited = true;
    originalOvertime.durationText = this.$filter("hms")(originalOvertime.acceptedOvertime);
    originalOvertime.newDuration = originalOvertime.acceptedOvertime;
  }

  checkOvertime(overtime){
    return overtime.durationText === this.$filter("hms")("PT0H");
  }

  editOvertimeSave(originalOvertime) {
    originalOvertime.saving = true;
    this.state = "loading";
    let overtime = {
      userId: originalOvertime.userId,
      date: originalOvertime.date,
      duration: originalOvertime.newDuration,
      comment: originalOvertime.comment
    };

    if(originalOvertime.newDuration === undefined){
      overtime = {
        userId: originalOvertime.userId,
        date: originalOvertime.date,
        duration: originalOvertime.reportedOvertime,
        comment: originalOvertime.comment
      };
    }

    if(overtime.duration) {
      this.Stats.editOvertime(overtime).then(
        () => {
          this.refreshOvertime(originalOvertime, 'update');
        },
        () => {
          this.state = "error";
          originalOvertime.saving = false;
          originalOvertime.error = true;
        }
      );
    } else {
      this.editOvertimeCancel(originalOvertime);
      originalOvertime.saving = false;
      this.state = "loaded";
    }
  }

  editOvertimeDecline(overtime) {
    this.state = "loading";
    let overtimeDeclined = {
      userId: overtime.userId,
      date: overtime.date,
      duration: moment.duration(this.$filter("hms")("PT0H")),
      comment: overtime.comment
    };

    return this.Stats.editOvertime(overtimeDeclined).then(
      () => {
        return Promise.resolve();
      },
      () => {
        this.state = "error";
        overtimeDeclined.error = true;
        return Promise.reject();
      }
    ).then( () => {
      this.refreshOvertime(overtimeDeclined, 'update');
    });
  }

  editOvertimeCancel(overtime) {
    delete overtime.newDuration;
    delete overtime.durationInvalid;
    delete overtime.durationText;
    overtime.comment = overtime.overtimeAcceptComment;
    overtime.edited = false;
    overtime.error = false;
  }

  updateDuration(overtime) {
    var format = /\d+:\d\d:\d\d/;
    var match = overtime.durationText.match(format);
    const previousDuration = overtime.reportedOvertime && moment.duration(overtime.reportedOvertime);
    const previousDurationMatch = overtime.reportedOvertime && this.$filter("hms")(overtime.reportedOvertime).match(format);
    const isPreviousDurationMatchSameAsNewMatch = match && previousDurationMatch && match[0] == previousDurationMatch[0];
    if(match && match.length == 1) {
      const newDuration = moment.duration(match[0]);
      // handle miliseconds precision when no duration change
      overtime.newDuration = isPreviousDurationMatchSameAsNewMatch && previousDuration || newDuration;
      overtime.durationInvalid = false;
    } else {
      overtime.newDuration = undefined;
      overtime.durationInvalid = true;
    }
  }

  translateNorm(label){
    if(label === "Hourly"){
      return this.$translate.instant("POSITION.HOURLYNORM");
    }
    if(label === "Worknorm"){
      return this.$translate.instant("POSITION.WORKNORM");
    }
    if(label === "LongTermLeave"){
      return this.$translate.instant("POSITION.LONGTERMLEAVE");
    }
    return label;
  }

  openShareModal(user){
    this.overtimeUserModal = user;
    this.showModal = true;
  }

  openSettleModal(user){
    this.overtimeUserModal = user;
    this.showSettleModal = true;
  }

  closeShareModal(){
    this.showModal = false;
  }

  updateView(){
    this.stateLoadingBalance = "loading";
    this.refreshOvertime(null, 'update');
  }
}
